import Tasks from '../../controllers/tasks';
import Dnd from '../../grid/dnd';

export default instance => (taskId, event) => {
  const chartState = instance.getState();
  const isChartDnD = chartState.drag_mode === 'move' || chartState.drag_mode === 'resize';

  if (Dnd.isDragging || isChartDnD) return;

  let taskIdForHover = taskId;

  if (!taskIdForHover) {
    const ganttTaskRow = event.target.closest('.gantt_task_row');

    ganttTaskRow && (taskIdForHover = ganttTaskRow.dataset.taskId);
  }

  const task = taskIdForHover && instance.isTaskExists(taskIdForHover) ? instance.getTask(taskIdForHover) : null;
  const isButtonType = task?.type === instance.config.types.button;

  Tasks.setHoverTaskRow(isButtonType ? null : taskIdForHover);
};
